import { helpers } from 'vuelidate/lib/validators';

export default function (value) {
    if (!helpers.req(value)) {
        return true;
    }

    try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(`<div>${value}</div>`, 'text/html');
        const parserErrors = doc.querySelector('parsererror');
        if (parserErrors) {
            console.log('parserErrors', parserErrors.textContent);

            return false;
        }

        // Check for incomplete tags (< without > or </ without >)
        const incompleteTagPattern = /<[^>]*(?<!>)$/m;
        if (incompleteTagPattern.test(value)) {
            return false;
        }

        const selfClosingTags = ['br', 'img', 'hr', 'meta', 'link', 'input'];
        const selfClosingRegex = selfClosingTags
            .map((tag) => `${tag}(?:\\s[^>]*)?`)
            .join('|');
        const openingTags = (
            value.match(
                new RegExp(`<(?!\!|\/|${selfClosingRegex})\\w+\\b[^>]*>`, 'gi')
            ) || []
        ).length;
        const closingTags = (value.match(/<\/\w+>/gi) || []).length;

        return openingTags === closingTags;
    } catch (e) {
        console.error('HTML validation error:', e);
        return false;
    }
}
